import { createFileRoute } from "@tanstack/react-router";
import { EditRecipePage } from "./-EditRecipePage";

export const Route = createFileRoute(
  "/_app/_recipe-page/recipes/$recipeId_/edit",
)({
  component: () => <EditRecipePage recipeId={Route.useParams().recipeId} />,
});
